import { conf } from '@/config/conf'
import axios from 'axios'
import store from '@/store'

interface InvoiceRequestArgs {
    objectId?: string|number
    filter?: []
    sort?: []
}

export function getInvoiceRequest(args: InvoiceRequestArgs = {}) {
    return new Promise(( resolve, reject ) => {
        const request = axios({
            url: conf.apiUrl + '/Invoice/getInvoice',
            method: "POST",
            data: args || {},
            headers: {
                xsrf: conf.xsrf,
                Authorization: 'Bearer ' + store.getters.user.accessToken
            }
        });

        request.then(function( res: any ) {
            resolve(res.data)
        });

        request.catch(function( reason: any) {
            reject(reason)
            // TODO:  general error handler !!
        });
    })
}